import axios from 'axios';
import jwtDecode from 'jwt-decode';
import { KEY_AUTH_HEADER, KEY_AUTH_BEARER, KEY_TOKEN } from '../config/appConfig'
import { AUTH_GET_DATA } from '../redux/types'
import { isEmpty } from '../utils/validations'

/**
 * Ingresa el token en los headers de axios o lo elimina
 */
export const setAuthToken = (token: string) => {
  if (token) {
    axios.defaults.headers.common[KEY_AUTH_HEADER] = `${KEY_AUTH_BEARER} ${token}`;
  } else {
    delete axios.defaults.headers.common[KEY_AUTH_HEADER];
  }
};

/**
 * Configura al usuario actual tras obtener respuesta del servidor
 */
export const configUserFromResponse = (response, dispatch) => {
  const decoded = getTokenFromResponse(response)
  if (isEmpty(decoded)) return;

  setUserToState(decoded, dispatch)
}

/**
 * Ejecuta una funcion para ingresar la informacion del usuario en Redux 
 */
export const setUserToState = (payload, dispatch) => {
  dispatch({
    type: AUTH_GET_DATA,
    payload
  })
}

/**
 * Obtiene el token desde una respuesta del servidor,
 * lo decodifica y retorna el objeto de respuesta
 * 
 * Tambien ingresa el token que llega como STRING a AXIOS y tambien localStorage
 * para su proximo uso
 */
export const getTokenFromResponse = (response) => {
  const { token } = response;
  if (isEmpty(token)) return null;

  let decoded = null;

  try {
    decoded = jwtDecode(token);
  } catch (err) {
    console.log(err);
  }

  if (decoded) {
    localStorage.setItem(KEY_TOKEN, token);
    setAuthToken(token);
  }

  return decoded;
};

export const removeToken = () => {
  setAuthToken(null)
  localStorage.removeItem(KEY_TOKEN)
}